import { render } from "./AnnouncementDetail.vue?vue&type=template&id=179f7d73"
import script from "./AnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&lang=js"
script.render = render

export default script